
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"47","height":"47","rx":"9.5","fill":"#293343","stroke":"#F0F0F2"}}),_c('mask',{attrs:{"id":"a","fill":"#fff"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M27.005 25.424c-.131.202-.2.438-.2.679v4.965c0 .449-.241.863-.632 1.086l-3.111 1.773a1.25 1.25 0 01-1.87-1.086v-6.74c0-.24-.069-.476-.2-.679l-6.114-9.454a1.25 1.25 0 011.05-1.929H32.07a1.25 1.25 0 011.05 1.929l-6.115 9.456z"}})]),_c('path',{attrs:{"d":"M14.878 15.968l-.84.543.84-.543zm6.114 9.454l-.84.543.84-.543zm2.07 8.505l-.496-.868.495.868zm2.742-7.824v4.965h2v-4.965h-2zm-.126 5.182l-3.112 1.774.99 1.737 3.113-1.773-.99-1.738zm-3.486 1.556v-6.74h-2v6.74h2zm-.36-7.962l-6.114-9.454-1.68 1.086 6.114 9.454 1.68-1.086zm-5.904-9.84H32.07v-2H15.928v2zm16.352.386l-6.115 9.456 1.68 1.086 6.114-9.456-1.68-1.086zm-.21-.386a.25.25 0 01.21.386l1.68 1.086c.968-1.497-.107-3.472-1.89-3.472v2zm-16.352.386a.25.25 0 01.21-.386v-2c-1.783 0-2.858 1.975-1.89 3.472l1.68-1.086zM22.192 26.1a2.25 2.25 0 00-.36-1.222l-1.68 1.086a.25.25 0 01.04.136h2zm.374 6.958a.25.25 0 01-.373-.218h-2c0 1.727 1.864 2.81 3.364 1.955l-.99-1.737zm3.238-1.991a.25.25 0 01-.126.217l.99 1.738a2.25 2.25 0 001.136-1.955h-2zm2-4.965a.25.25 0 01.04-.136l-1.679-1.086a2.25 2.25 0 00-.36 1.222h2z","fill":"#fff","mask":"url(#a)"}})])
          )
        }
      }
    